.form-container {
    overflow: auto;
}

.form-container form {
    padding-bottom: 64px;
}
